// Create a self-executing function to avoid global scope pollution
(function() {
  function initVariantGrouper() {
    // Wait for Boost to render products
    const productsContainer = document.getElementById('bc-sf-filter-products');
    if (!productsContainer) return;

    // Observer to watch for product additions
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.classList && node.classList.contains('product-grid')) {
              enhanceProductSwatches(node);
            }
          });
        }
      });
    });

    // Start observing
    observer.observe(productsContainer, {
      childList: true,
      subtree: true
    });
  }

  function enhanceProductSwatches(productElement) {
    const quickAddBtn = productElement.querySelector('.js-quick-add');
    if (!quickAddBtn) return;

    const baseTitle = quickAddBtn.getAttribute('data-pr-title');
    const currentColor = quickAddBtn.getAttribute('data-color');
    
    // Use the same search approach as quick buy
    const search_url = `https://${window.location.hostname}/search?view=json&q="${encodeURI(baseTitle)}"`;
    
    fetch(search_url)
      .then(response => response.json())
      .then(data => {
        const allVariants = data.results.filter(result => 
          result.available && 
          handleize(result.title.split(' - ')[0]) === handleize(baseTitle)
        );

        if (allVariants.length > 0) {
          updateColorSwatches(productElement, allVariants);
        }
      })
      .catch(error => console.log('Error fetching variants:', error));
  }

  function updateColorSwatches(productElement, variants) {
    const swatchesContainer = productElement.querySelector('.color-swatches-container');
    if (!swatchesContainer) return;

    const seenColors = new Set();
    let swatchesHtml = '';

    variants.forEach(variant => {
      const colorOption = variant.options_with_values.find(opt => 
        opt.name.toLowerCase() === 'color'
      );
      
      if (colorOption) {
        colorOption.values.forEach(color => {
          if (!seenColors.has(color.title)) {
            seenColors.add(color.title);
            // Use same swatch construction as quick buy
            swatchesHtml += buildColorSwatch(variant, color);
          }
        });
      }
    });

    swatchesContainer.innerHTML = swatchesHtml;
  }

  // Helper function to match quick buy swatch construction
  function buildColorSwatch(variant, color) {
    const colorTitle = color.title.toLowerCase();
    const formattedColor = colorTitle.replace(/\s+/g, '');
    const swatchUrl = `https://cdn.shopify.com/s/files/1/0063/4932/4335/t/159/assets/${variant.handle}_${formattedColor}_swatch.jpg`;
    
    return `
      <div class="color-swatch" data-color="${color.title}">
        <img src="${swatchUrl}" 
             alt="${color.title}" 
             title="${color.title}" 
             class="color-swatch__img" 
             style="width: 24px; height: 24px; border-radius: 50%; margin: 0 4px; cursor: pointer;"
             onmouseover="this.style.transform='scale(1.1)'"
             onmouseout="this.style.transform='scale(1)'"
             onerror="this.style.display='none'"
        />
      </div>
    `;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantGrouper);
  } else {
    initVariantGrouper();
  }
})();
